module.exports = __webpack_public_path__ + "img/winner-7th.80699892.png";